import { Suspense } from 'react';
import '@weareopenr/component-library/build/global.scss';
import { HeaderSnackbarProvider, HeaderSnackbarViewport, Spinner } from '@weareopenr/component-library';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { SpinnerContainer } from 'src/components/SpinnerContainer';
import 'src/assets/theme/global.scss';
import { WorkOSAuthProvider } from '@weareopenr/authkit';
import { PostHogProvider } from '@posthog/react';
import { ConfigDefaults } from 'posthog-js';
import { Outlet } from 'react-router-dom';
import { ErrorBoundary } from './components/ErrorBoundary/ErrorBoundary';

declare global {
  interface Window {
    Cypress: Cypress.Cypress;
  }
}

const ConditionalPostHogProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
  const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;

  if (!POSTHOG_KEY || !POSTHOG_HOST) {
    return <>{children}</>;
  }

  const options = {
    api_host: POSTHOG_HOST,
    defaults: '2025-05-24' as ConfigDefaults,
  };

  return (
    <PostHogProvider apiKey={POSTHOG_KEY} options={options}>
      {children}
    </PostHogProvider>
  );
};

const App = () => {
  return (
    <ConditionalPostHogProvider>
      <ErrorBoundary withRouter={false}>
        <WorkOSAuthProvider clientId={process.env.REACT_APP_WORKOS_CLIENT_ID}>
          <HeaderSnackbarProvider>
            <Suspense
              fallback={
                <SpinnerContainer>
                  <Spinner size="xlarge" colour="rainbow" />
                </SpinnerContainer>
              }
            >
              <Outlet />
            </Suspense>
            <HeaderSnackbarViewport />
          </HeaderSnackbarProvider>
          <ScrollToTop />
        </WorkOSAuthProvider>
      </ErrorBoundary>
    </ConditionalPostHogProvider>
  );
};

export default App;
